import { ChangeDetectorRef, Component, inject, OnInit, DestroyRef } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { Subscription } from "rxjs";
import { DashboardsService, AuthService } from "@shared/index";
import { CardModalService } from "@shared/card-modal";
import { SharedModule } from "@shared/shared.module";
import { IDashboardModel } from "@app/views-interfaces/dashboard-model.interface";
import {
    IfirmtaxprepNorthPanelComponent,
    JobsBillingNorthPanelComponent,
    TaxprepNorthPanelComponent,
    PanelIconsComponent,
} from "@app/card-modal-component/panels/north-panels";
import { isJobsBilling, isiFirmTax, isTaxprep } from "@app/views-interfaces/ApplicationType.enum";

@Component({
    selector: "wk-north-panel",
    imports: [
        PanelIconsComponent,
        IfirmtaxprepNorthPanelComponent,
        TaxprepNorthPanelComponent,
        JobsBillingNorthPanelComponent,
        TranslateModule,
        JumpstartComponentsModule,
        SharedModule,
    ],
    templateUrl: "./north-panel.component.html",
    styleUrl: "./north-panel.component.scss",
    host: { class: "wk-cm__north-panel" },
})
export class NorthPanelComponent implements OnInit {
    private readonly destroyRef = inject(DestroyRef);
    private readonly dashboardsService = inject(DashboardsService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    public readonly cardModalService = inject(CardModalService);
    private readonly authService = inject(AuthService);

    isTaxpayerNameOverflow = false;
    currentDashboard: IDashboardModel;
    currentDashboardChangedSubscription: Subscription;
    userCanDeleteCard = false;
    isJobsBillingNorthPanelVisible = false;
    isTaxPrepNorthPanelVisible = false;
    isIFirmTaxprepNorthPanelVisible = false;

    constructor() {
        this.currentDashboardChangedSubscription = this.dashboardsService.currentDashboardChanged$.subscribe(() => {
            this.init();
        });

        this.destroyRef.onDestroy(() => {
            this.currentDashboardChangedSubscription.unsubscribe();
        });
    }

    ngOnInit() {
        this.init();
    }

    async init() {
        this.currentDashboard = await this.dashboardsService.getCurrentDashboard();
        this.userCanDeleteCard = this.authService.currentUser.can_delete_cards === "True";
        this.isJobsBillingNorthPanelVisible = isJobsBilling(this.currentDashboard?.ApplicationType);
        this.isTaxPrepNorthPanelVisible = isTaxprep(this.currentDashboard?.ApplicationType);
        this.isIFirmTaxprepNorthPanelVisible = isiFirmTax(this.currentDashboard?.ApplicationType);

        this.changeDetectorRef.detectChanges();
    }

    isEllipsisActive(event: FocusEvent): void {
        const element = event.target as HTMLElement;
        if (element.offsetWidth < element.scrollWidth) {
            this.isTaxpayerNameOverflow = true;
        } else {
            this.isTaxpayerNameOverflow = false;
        }
    }

    handleOpenInApp(event): void {
        // Skip Enter Key on Date Pickers
        if (event.clientX !== 0 || event.clientY !== 0) {
            this.cardModalService.openInApp.set(this.currentDashboard?.ApplicationType);
        }
    }

    handleOpenAudit() {
        this.cardModalService.auditWindowOpen.set(true);
    }

    handleVipChange() {
        const formGroup = this.cardModalService.cardModalFormGroup();
        if (formGroup) {
            formGroup?.get("vip")?.setValue(!this.cardModalService.isVIP());
            formGroup?.get("vip")?.markAsDirty();
            this.cardModalService.isVIP.set(!this.cardModalService.isVIP());
        }
    }

    handleOpenInContact(): void {
        this.cardModalService.openContact.set(true);
    }

    handleOpenInPortal(): void {
        this.cardModalService.openPortal.set(true);
    }

    handleDeleteCard(): void {
        this.cardModalService.deleteCard.set(true);
    }

    handleOpenIniFirmTaxprep(): void {
        this.cardModalService.openIniFirmTaxprep.set(true);
    }
}
